import React, { useState, useEffect, FormEvent, ChangeEvent } from 'react';
import axios from 'axios';
import { API_IMAGES, API_URL, config } from '../components/Include';
import { useSelector } from 'react-redux';
import { Alerts } from '../components/notify';
import './profile.css';

const Profile = () => {
  const student = useSelector((state: any) => state.rootReducer.student);
  const [profile, setProfile] = useState({} as any);
  const [errors, setErrors] = useState({
    errorMessage: '',
    marital_status: '',
    telephone: '',
    religion: '',
    birth_date: '',
    email_address: '',
    home_town: '',
    imagesFile: '',
    is_loading: false
  });

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    let { name, value } = event.target;
    if (name === 'telephone') {
      value = value.slice(0, 11);
    }
    setProfile({ ...profile, [name]: value });
    setErrors({ ...errors, [name]: '' });
  };

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    let formIsValid = true;
    const email = profile.email_address?.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);

    if (!email) {
      Alerts('danger', 'Please enter valid email address', 'Error!');
      formIsValid = false;
    }

    //if email contain nsuk.edu.ng set to false
    if (profile.email_address?.includes('nsuk.edu.ng')) {
      Alerts('danger', 'Please use personal email address', 'Error!');
      setErrors({ ...errors, email_address: 'Please use personal email address' });
      formIsValid = false;
    }



    if (formIsValid) {
      // Show loader
      setErrors({ ...errors, is_loading: true });
      
      const fd = new FormData();
      Object.entries(profile).forEach(([key, value]) => {
        fd.append(key, String(value));
      });

      const url = API_URL + '/student/update';
      axios.post(url, fd, config)
        .then((response: any) => {
          if (response.data.status === 200) {
            // Redirect to next page
            window.open('/app/skills', '_self');
          } else {
            Alerts('danger', response.data.message, 'Something went wrong');
          }
        })
        .catch((error) => {
          Alerts('danger', error.message, 'Error');
        })
        .finally(() => {
          setErrors({ ...errors, is_loading: false });
        });
    }
  };

  useEffect(() => {
    setProfile(student);
  }, [student]);

  return (
    <>
      {/* Loading Overlay */}
      {errors.is_loading && (
        <div className="overlay">
          <img src="/images/loader.svg" alt="loader" />
        </div>
      )}

      {/* Profile Header */}
      <div className="profile-container mt-4">
      <div className="payment-header">
          <h4>
            <i className="fa fa-credit-card me-2"></i> Personal Profile
          </h4>
          <ol className="breadcrumb payment-breadcrumb">
            <li className="breadcrumb-item">
              <a href="#">Home</a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Profile
            </li>
          </ol>
        </div>

        {/* Alert Message */}
        <div className="profile-alert">
          <p className="mb-0">
            Please review your details and confirm your email address below. Any other necessary changes can be made via your NSUK Portal or by visiting NSUK ICT.
          </p>
        </div>

        {/* Profile Information */}
        <div className="profile-info-section p-4">
          <form onSubmit={handleSubmit}>
            <div className="row">
              {/* Avatar Section */}
              <div className="col-lg-3 col-md-4 mb-4">
                <div className="text-center">
                  <div className="profile-avatar">
                    <i className={`fa fa-${profile.gender === 'male' ? 'male' : 'female'}`}></i>
                  </div>
                  <h5 className="mt-3 mb-1">{profile.surname} {profile.firstname}</h5>
                  <p className="text-muted">{profile.matric_no || 'Student'}</p>
                </div>
              </div>
              
              {/* Profile Details */}
              <div className="col-lg-9 col-md-8">
                <div className="profile-info-card">
                  <div className="profile-info-header">
                    <h5 className="mb-0">Basic Information</h5>
                  </div>
                  <div className="profile-info-body">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="profile-info-group">
                          <label className="profile-info-label">Matric No.</label>
                          <input 
                            type="text" 
                            className="form-control profile-info-value" 
                            name="matric_no" 
                            value={profile.matric_no} 
                            onChange={handleChange} 
                            disabled 
                          />
                        </div>
                        
                        <div className="profile-info-group">
                          <label className="profile-info-label">Email Address</label>
                          <input 
                            type="email" 
                            className={errors.email_address ? 'form-control  bg-white is-invalid' : 'form-control  bg-white'}
                            name="email_address" 
                            
                            value={profile.email_address || ''} 
                            onChange={handleChange} 
                            required 
                          />
                          {errors.email_address && <span className="text-danger">{errors.email_address}</span>}
                          {profile.email_verify === 'Yes' && <span className="verified-badge">Verified</span>}
                        </div>
                        
                        <div className="profile-info-group">
                          <label className="profile-info-label">Program</label>
                          <input 
                            type="text" 
                            className="form-control profile-info-value" 
                            name="department" 
                            value={profile.department} 
                            onChange={handleChange} 
                            disabled 
                          />
                        </div>
                      </div>
                      
                      <div className="col-md-6">
                        <div className="profile-info-group">
                          <label className="profile-info-label">
                            Gender <span className="text-danger">*</span>
                          </label>
                          <input 
                            type="text" 
                            className="form-control profile-info-value" 
                            name="gender" 
                            value={profile.gender} 
                            onChange={handleChange} 
                            disabled 
                          />
                        </div>
                        
                        <div className="profile-info-group">
                          <label className="profile-info-label">
                            Telephone <span className="text-danger">*</span>
                            {profile.phone_verify === 'Yes' && <span className="verified-badge">Verified</span>}
                          </label>
                          <input 
                            type="text" 
                            className="form-control profile-info-value bg-white" 
                            name="telephone" 
                            value={profile.telephone} 
                            placeholder="e.g 0803xxxxxxx" 
                            maxLength={11} 
                            onChange={handleChange} 
                            required 
                            disabled={profile.phone_verify === 'Yes'} 
                          />
                        </div>
                        
                        <div className="profile-info-group">
                          <label className="profile-info-label">
                            Current Level <span className="text-danger">*</span>
                          </label>
                          <input 
                            type="text" 
                            className="form-control profile-info-value" 
                            name="level" 
                            value={profile.level} 
                            onChange={handleChange} 
                            required 
                            disabled 
                          />
                        </div>
                      </div>
                    </div>
                    
                    <div className="row mt-3">
                      <div className="col-md-6">
                        <div className="profile-info-group">
                          <label className="profile-info-label">
                            Study Mode <span className="text-danger">*</span>
                          </label>
                          <input 
                            type="text" 
                            className="form-control profile-info-value" 
                            name="study_mode" 
                            value={profile.study_mode} 
                            onChange={handleChange} 
                            required 
                            disabled 
                          />
                        </div>
                      </div>
                      
                      <div className="col-md-6">
                        <div className="profile-info-group">
                          <label className="profile-info-label">Admission Session</label>
                          <input 
                            type="text" 
                            className="form-control profile-info-value" 
                            name="session" 
                            value={profile.session} 
                            onChange={handleChange} 
                            disabled 
                          />
                        </div>
                      </div>
                    </div>
                    
                    <div className="row mt-4">
                      <div className="col-12 text-end">
                        <button type="submit" className="profile-submit-btn">
                          Save & Continue
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Profile;
